class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.onVariantChange = this.onVariantChange.bind(this);
    this.addEventListener('change', this.onVariantChange);
  }

  connectedCallback() {
    this.onVariantChange();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.setUnavailable();
      return;
    }

    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
const variant = this.currentVariant; // ✅ store BEFORE DOM change

this.renderProductInfo().then(() => {
  this.currentVariant = variant; // ✅ restore after DOM replace
  this.updateButtonState();      // now safe
});

    // Swatch update
    const colorValue = this.currentVariant.options[0];
    const swatchContainer = document.querySelector('.product-swatch-color');

    if (swatchContainer) {
      swatchContainer.querySelectorAll('.swatch-element').forEach((swatch) => {
        swatch.classList.toggle(
          'active',
          swatch.getAttribute('data-value') === colorValue
        );
      });
    }
  }

  // 🔥 FIXED STOCK LOGIC
updateButtonState(variant = this.currentVariant) {
  if (!variant) {
    this.setUnavailable();
    return;
  }

  const isOutOfStock = !variant.available;

  this.toggleAddButton(isOutOfStock, window.variantStrings.notify_me);

  const availabilityEl = document.querySelector('[data-availability]');
  if (availabilityEl) {
    availabilityEl.textContent = isOutOfStock
      ? 'OUT OF STOCK'
      : 'IN STOCK';
  }
}

  //   const variant_id = this.currentVariant.id;

  //   const option = document
  //     .getElementById('productSelect')
  //     ?.querySelector(`[value="${variant_id}"]`);

  //   const qty = parseInt(option?.getAttribute('data-qty') || '0', 10);

  //   const isOutOfStock = qty < 1;

  //   this.toggleAddButton(isOutOfStock, window.variantStrings.notify_me);
  // }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select'),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => this.options[index] === option)
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant?.featured_media) return;

    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;

    document
      .querySelectorAll('.FeaturedImage_slick .item')
      .forEach((el) => el.classList.remove('act'));

    newMedia.classList.add('act');

    if (window.jQuery?.fn?.slick) {
      const $ = window.jQuery;
      const $slick = $('.FeaturedImage_slick');

      const $slide = $slick
        .find(`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`)
        .closest('.slick-slide');

      if ($slide.length) {
        $slick.slick('slickGoTo', $slide.data('slick-index'));
      }
    }
  }

  updateURL() {
    if (!this.currentVariant) return;

    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    document
      .querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment`
      )
      .forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        if (!input) return;

        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    return fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((res) => res.text())
      .then((htmlText) => {
        const html = new DOMParser().parseFromString(htmlText, 'text/html');

        const id = `ProductPrice-${this.dataset.section}`;
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) {
          destination.innerHTML = source.innerHTML;
        }

        document
          .getElementById(`price-${this.dataset.section}`)
          ?.classList.remove('visibility-hidden');

        // SKU FIX
        const variant_id = document.getElementById('variant_id')?.value;

        const option = document
          .getElementById('productSelect')
          ?.querySelector(`[value="${variant_id}"]`);

        const sku = option?.getAttribute('data-sku');

        const variantSku = document.getElementById('variantSku');

        if (variantSku && sku) {
          variantSku.innerHTML = sku;
        }
      });
  }

  // 🔥 CLEAN BUTTON CONTROL (NO BUGS)
  toggleAddButton(disable = true, text) {
    const form = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!form) return;

    const addWrapper = form.querySelector('.product-form__item--submit');
    const addButton = form.querySelector('[name="add"]');
    const notifyBtn = form.querySelector('[name="add2"]');

    if (!addWrapper || !notifyBtn) return;

    if (disable) {
      addWrapper.classList.add('hidden-force');

      if (addButton) {
        addButton.setAttribute('disabled', true);
        addButton.style.display = 'none';
      }

      notifyBtn.style.display = 'flex';

      const txt = notifyBtn.querySelector('#txt-notify');
      if (text && txt) txt.textContent = text;

    } else {
      addWrapper.classList.remove('hidden-force');

      if (addButton) {
        addButton.removeAttribute('disabled');
        addButton.style.display = 'inline-block';
      }

      notifyBtn.style.display = 'none';

      // Button text logic
      const variant_id =
        document.getElementById('variant_id')?.value ||
        this.currentVariant?.id;

      const option = document
        .getElementById('productSelect')
        ?.querySelector(`[value="${variant_id}"]`);

      const txtBtn = addButton?.querySelector('#AddToCartText');

if (txtBtn) {
  txtBtn.textContent = this.currentVariant.available
    ? window.variantStrings.addToCart
    : window.variantStrings.soldOut;
}
    }
  }

  setUnavailable() {
    const form = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!form) return;

    const addWrapper = form.querySelector('.product-form__item--submit');
    const addButton = form.querySelector('[name="add"]');
    const notifyBtn = form.querySelector('[name="add2"]');

    if (addWrapper) addWrapper.classList.add('hidden-force');
    if (notifyBtn) notifyBtn.style.display = 'flex';
    if (addButton) addButton.setAttribute('disabled', true);

    document
      .getElementById(`ProductPrice-${this.dataset.section}`)
      ?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(
        this.querySelector('[type="application/json"]').textContent
      );
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));

    this.options = fieldsets.map((fieldset) => {
      return fieldset.querySelector('input:checked')?.value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);


document.addEventListener("change", function (e) {

  if (!e.target.matches('input[type="radio"], select')) return;

  const form = e.target.closest("form");
  if (!form) return;

  setTimeout(() => {

    const jsonScript = form.querySelector('[type="application/json"]');
    if (!jsonScript) return;

    const variants = JSON.parse(jsonScript.textContent);

    // ✅ Get selected variant
// 🔥 Get selected options (size, color, etc.)
const selectedOptions = [];
form.querySelectorAll('input[type="radio"]:checked, select').forEach(el => {
  selectedOptions.push(el.value);
});

// 🔥 Find correct variant
const selectedVariant = variants.find(variant => {
  return variant.options.every((option, index) => {
    return option === selectedOptions[index];
  });
});

    const addBtn = form.querySelector('[name="add"]');
    const notifyBtn = form.querySelector('[name="add2"]');
    const availability = document.getElementById("availability-status");

    if (!selectedVariant) return;

    // ✅ ONLY THIS MATTERS
    if (selectedVariant.available) {

      addBtn.style.display = "block";
      notifyBtn.style.display = "none";

      if (availability) {
        availability.innerHTML = `
          <span class="in-stock-text">IN STOCK</span>
          <i class="fa fa-check-square-o"></i>
        `;
      }

    } else {

      addBtn.style.display = "none";
      notifyBtn.style.display = "flex";

      if (availability) {
        availability.innerHTML = `
          <span class="sold-out-text">OUT OF STOCK</span>
          <i class="fa fa-ban"></i>
        `;
      }
    }

  }, 50); // reduced delay, 100ms unnecessary
});